import Wordmark from "../../components/Wordmark/Wordmark";

interface FooterProps {
  hideNav?: boolean;
}

const legalLinks = [
  { label: "Termos de uso" },
  { label: "Privacidade" },
  { label: "Ajuda" },
];

function Footer({ hideNav }: FooterProps): JSX.Element | null {
  if (hideNav) return null;

  const copyright = `© ${new Date().getFullYear()} Acertei. Todos os direitos reservados.`;

  return (
    <footer className="border-t border-edge bg-footer-bg text-ink-muted">
      {/* Desktop/tablet: tagline+copyright, links, wordmark — one row, frame mAe4c */}
      <div className="hidden md:flex flex-wrap items-center justify-between gap-6 px-8 py-5">
        <div className="flex flex-col">
          <span className="text-sm font-semibold text-ink">
            Plataforma de estudos estratégicos
          </span>
          <span className="text-xs text-ink-muted">{copyright}</span>
        </div>

        <div className="flex items-center gap-5">
          {legalLinks.map((link) => (
            <span key={link.label} className="text-sm font-medium text-ink-secondary cursor-default">
              {link.label}
            </span>
          ))}
        </div>

        <Wordmark
          width={120}
          className="shrink-0"
          to="/home"
          label="Acertei — ir para a Home"
        />
      </div>

      {/* Mobile: wordmark, tagline, links, copyright — stacked and centered, frame UD407/xlGFn */}
      <div className="flex md:hidden flex-col items-center gap-3.5 px-6 py-6 text-center">
        <Wordmark width={128} to="/home" label="Acertei — ir para a Home" />
        <span className="text-sm font-semibold text-ink">
          Plataforma de estudos estratégicos
        </span>
        <div className="flex items-center gap-[18px]">
          {legalLinks.map((link) => (
            <span key={link.label} className="text-sm font-medium text-ink-secondary cursor-default">
              {link.label}
            </span>
          ))}
        </div>
        <span className="text-xs text-ink-muted">{copyright}</span>
      </div>
    </footer>
  );
}

export default Footer;
